import { useState, useEffect } from 'react';

function useNavigationURL() {
    const [navigationURL, setNavigationURL] = useState<string>(process.env.NEXT_PUBLIC_PROXY_PATH || '');

    useEffect(() => {
        function constructNavigationURL() {

            const currentURL = window.location.href;
            const url = new URL(currentURL);
            const pathAfterDomain = url.pathname;

            const splitPath = pathAfterDomain.split(process.env.NEXT_PUBLIC_PROXY_PATH);
            const localePath = splitPath[0]; // This will give us the locale or empty string if none

            const constructedURL = `${localePath}${process.env.NEXT_PUBLIC_PROXY_PATH}`;
            setNavigationURL(constructedURL);
        }

        if (typeof window !== 'undefined' && (window as any).Shopify) {
            constructNavigationURL();
        }
    }, []);

    return navigationURL;
}

export default useNavigationURL;